<template>
	<div class="pdf_dialog" v-loading="loading"
		 :element-loading-text="$t('seller.upload.autoFill.inProgress')"
	>
		<div class="drak"></div>
		<div class="pdf_content" :class="{'hide_left' : hideLeft}">
			<md-card>
				<md-card-content style="height:100%">
					<div class="md-layout" style="height:100%;overflow:auto">
						<div class="close_box" @click.stop="close">
							<i class="el-dialog__close el-icon el-icon-close"></i>
						</div>
						<div v-if="!hideLeft" class="pdf_list">
							<EditPdfLeft :getDetail="getDetail" :activeId="activeId"></EditPdfLeft>
						</div>
						<div v-if="!hideLeft" class="md-layout-item pdf_iframe flex_3">
							<PdfView></PdfView>
						</div>
						<div class="md-layout-item pdf_form">
							<PdfForm :getDetail="getDetail" :onChange="onChange"></PdfForm>
						</div>
					</div>
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>
<script>
import PdfView from "./PdfView";
import PdfForm from "./PdfForm";
import EditPdfLeft from "./EditPdfLeft";
import {mapGetters} from "vuex";
import {receivableApi} from "@/common/api/receivableApi";

export default {
	components: {
		PdfView,
		PdfForm,
		EditPdfLeft
	},
	data() {
		return {
			filImg: require("@/assets/img/file-icon.png"),
			pdfStatus: 3,
			saveNum: 0,
			submitNum: 0,
			activeId: "",
			loading: false
		};
	},
	created() {
		// tableItemData
		if (this.pafList && this.pafList.length > 0) {
			let id = this.pafList[0].receivableId;
			this.getDetail(id);
			this.$store.dispatch("setActionActivePdf", this.pafList[0]);
		} else {
      this.getDetail(-1);
    }
	},
	mounted() {
		// receivableDetail
	},
	methods: {
		close() {
			this.$store.dispatch("setActionTableItemDetail", "");
			this.$store.dispatch("setActionPdfDialog", { show: false });
			this.$store.dispatch("setActionLastAddedDebtorResult", null);
		},
		getDetail(id) {
			this.activeId = id;
			this.loading = true;
			receivableApi
				.receivableDetailWithAutoFills(id)
				.then(res => {
					this.$store.dispatch("setActionTableItemDetail", res);
					if (res.autoFillErrors) { // A non-empty array indicates some errors occurred
						if (res.autoFillErrors.length > 0) { // If the errors are empty, that means we have no specific reasons and just display the general msg
							this.toast(res.autoFillErrors, "warning");
						}

						if (res.eInvoiceRecognized === false) {
							this.toast(this.$t("seller.upload.autoFill.eInvoice.failed"), "warning");
						} else if (res.aiRecognized === false) {
							this.toast(this.$t("seller.upload.autoFill.ai.failed"), "warning");
						}
					}

					// Same msg for now, no matter where the autofill data came from
					if (res.eInvoiceRecognized || res.aiRecognized) {
						this.toast(this.$t("seller.upload.autoFill.success"), "warning");
					}
					this.loading = false;
				})
				.catch(err => {
					this.toast(err);
					this.loading = false;
				});
		},

	},
	computed: {
		...mapGetters({
			tableItemData: "tableItemData",
			pafList: "pafList",
			hideLeft: "pdfDialogHideLeft",
			onChange: "pdfDialogOnChange"
		})
	}
};
</script>

<style lang="scss">
@import "@/assets/scss/base_variables.scss";

#app {
	.router_view {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
	}
}

.pdf_dialog {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 10;

	.pdf_list_box {
		overflow-y: auto;
		overflow-x: hidden;
	}

	.close_box {
		position: absolute;
		right: 0;
		top: 0;
		height: 50px;
		width: 50px;
		line-height: 50px;
		text-align: center;
		cursor: pointer;
	}

	.drak {
		width: 100%;
		height: 100%;
		position: absolute;
		background: rgba(0, 0, 0, 0.2);
		left: 0;
		top: 0;
		z-index: 1;
	}

	.pdf_form {
		min-width: 640px;
	}

	.pdf_content {
		width: 90%;
		height: 100%;
		max-width: 3000px;
		position: absolute;
		text-align: center;
		left: 50%;
		top: 50%;
		z-index: 20;
		transform: translate(-50%, -50%);
		display: flex;

		&.hide_left {
			width: 680px;
		}

		.pdf_list {
			text-align: center;
			max-width: 10%;

			.pdf_item {
				position: relative;
				margin-bottom: 30px;

				&.active_pdf {
					border: 1px solid $accent-color;
				}

				cursor: pointer;

				.pdf_status {
					position: absolute;
					top: 0;
					right: 70%;

					i {
						font-size: 1.28rem;
					}
				}

				i.file_bg {
					font-size: 3rem;
				}
			}
		}
	}
}
</style>
